<template>
    <div>
			<el-form :model="user" :rules="rules" ref="addUserForm" label-width="100px" size="small">
				<el-form-item label="姓名" prop="displayname" >
					<el-input v-model="user.displayname"></el-input>
				</el-form-item>
				<el-form-item label="手机号码" prop="phone" >
					<el-input v-model="user.phone"></el-input>
				</el-form-item>
				<el-form-item label="Email" prop="email">
					<el-input v-model="user.email" placeholder="请输入Email"></el-input>
				</el-form-item>
				<el-form-item label="角色" prop="type">
					<el-radio v-model="user.type" :label="0">普通用户</el-radio>
					<el-radio v-model="user.type" :label="1">管理员</el-radio>
				</el-form-item>
			</el-form>
			<div style="text-align: right;">
				<el-button type="primary" @click="submit()">确 定</el-button>
			</div>
		</div>
</template>

<script>
	import axios from "axios"
	import config from "../../../config/global.js";

	var addUserUrl = config.host + "/backend/user/adduser.json"
    export default {
    	name: "add-customer-panel",
			data:function () {
        	var validatorPhone = function (rule, phone, callback) {
						if(phone == null || phone == ""){
							callback(new Error("手机号码不能为空!"));
						}else if(!(/^1[3456789]\d{9}$/.test(phone))){
							callback(new Error("手机号码填写有误!"));
						}else{
							callback();
						}
					};
				return {
					user:{name:"",phone:"",email:"",type:0},
					operating:false,
					rules: {
						name: [
							{ required: true, message: '请输入姓名', trigger: 'blur' },
						],
						phone: [
							{ required: true, validator:validatorPhone },
						],
						sex: [
							{ required: true, message: '请选择性别', trigger: 'blur' }
						],
						email:[
							{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
						]
					},
				}
			},
			methods:{
				submit(){
					this.$refs.addUserForm.validate((valid) => {
						if (valid) {
							this.operating = true;
							axios({
								method: 'post',
								url:addUserUrl,
								data:this.user
							}).then((response)=>{
								var defaultResult = this.responseDefaultHandle(response);
								if(defaultResult == false )
									return;
								if(response.data.result == 1){
									this.$message({
										message: '添加成功',
										type: 'success'
									});
									this.$emit('addsuccess');
									this.reset();
								}else{
									this.$alert(response.data.emsg, '添加失败', {
										confirmButtonText: '确定'
									});
								}
								this.operating = false;
							}).catch((error)=>{
								this.operating = false;
								this.$alert(error.response.statusText, '添加失败', {
									confirmButtonText: '确定'
								});
							})
						} else {
							return false;
						}
					});
				},
				reset:function () {
					this.user = {name:"",phone:"",email:"",type:0};
					this.$refs.addCustomerForm.resetFields();
				}
			}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/user/AddUserPanel.vue